module.exports = __webpack_public_path__ + "img/regular_fault_in_care.978d5cee.svg";